export const getURLPathParams = () => {
  try {
    const queryString = window.location.search;
    return new URLSearchParams(queryString);
  } catch (error) {
    return [];
  }
};

export const getPathURL = ()=> {
  const url = window.location.href;
  const fragmeurl = url?.split('/');
  const country = fragmeurl[3];
  const currentView = fragmeurl[fragmeurl?.length -1];
  return {
    country,
    currentView,
  };
};
